module.exports = __webpack_public_path__ + "img/znt.9b8d3a39.png";